import AOS from 'aos';

const pageScrollAnim = () => {
	AOS.init({
		delay: 200,
		duration: 600,
		once: true,
	});
};

export default pageScrollAnim;



// WEBPACK FOOTER //
// ./scripts/modules/page-scroll-anim.js